import styled from "styled-components";

export const Legend = styled.legend`
    font: normal normal normal 14px/20px Circular Std Book;
    color: #454546;
    margin-bottom: 20px;
`;

export const ButtonContainer = styled.div`
    margin-top: 64px;
    margin-bottom: 20px;

    @media (max-width: 600px) {
        margin-bottom: 70px;
    }
`;

export const FormContainer = styled.div`
    width: 350px;

    @media (max-width: 500px){
        width: 100%;
    }
`;